import { useEffect, useState } from "react";
import { fetchBackupDeviceListAdmin } from "../../api/admin";
import { DeviceItem } from "../../view/contents/backup/backup.device.list";

interface Props {
  userAccount: string;
}

type DeviceListType = DeviceItem[];

const UserInfo = ({ userAccount }: Props) => {
  const [userInfo, setUserInfo] = useState<DeviceListType>([]);

  const matchedUser = userInfo.find((user) => user.userAccount === userAccount);

  // admin 계정으로 디바이스 목록 불러오기
  useEffect(() => {
    const adminUserId = localStorage.getItem("userId");

    const loadDeviceList = async () => {
      try {
        const response = await fetchBackupDeviceListAdmin(Number(adminUserId));
        console.log("📦 전체 응답:", response);

        if (response && response.userList) {
          setUserInfo(response.userList);
        }
      } catch (err) {
        console.error("🚨 오류 발생:", err);
      }
    };

    loadDeviceList();
  }, []);

  return (
    <div className="user-info">
      {matchedUser ? (
        <>
          <span>아이디: {matchedUser.userAccount}</span>
          <span>|</span>
          <span>이름: {matchedUser.userName || "미입력"}</span>
          <span>|</span>
          <span>이메일: {matchedUser.userEmail}</span>
        </>
      ) : (
        <span>유저 정보를 불러오는 중입니다...</span>
      )}
    </div>
  );
};

export default UserInfo;
